import gameIds from '../data/GameIds';

const initialState = {
  showSingleStepMasteredScreen: false,
  showAllStepsMasteredScreen: false,
  showAugmentationNavigationScreen: false,
  showThreeFailuresScreen: false,
  playFailureVO: false,
  version: 1,
};

const questNavigationReducer = (state = initialState, action) => {
  if (action.gameId !== gameIds.METAGAME) {
    return state;
  }
  if (action.payload && action.payload.location === 'sideQuest') {
    return state;
  }
  switch (action.type) {
    case 'SET_QUEST_STEP_COMPLETE':
      return {
        ...state,
        showSingleStepMasteredScreen: true,
        showAllStepsMasteredScreen: false,
        showThreeFailuresScreen: false,
        playFailureVO: false,
      };
    case 'SET_ALL_QUEST_STEPS_COMPLETE':
      return {
        ...state,
        showSingleStepMasteredScreen: false,
        showAllStepsMasteredScreen: true,
        showThreeFailuresScreen: false,
        playFailureVO: false,
      };

    // 3 Failures Screen
    case 'SHOW_THREE_FAILURES_SCREEN':
      return {
        ...state,
        showThreeFailuresScreen: true,
        showAllStepsMasteredScreen: false,
        showSingleStepMasteredScreen: false,
        playFailureVO: false,
      };

    case 'HIDE_THREE_FAILURES_SCREEN':
      return {
        ...state,
        showThreeFailuresScreen: false,
        playFailureVO: false,
      };

    case 'NOTIFY_STEP_FAILURE_QUEST':
      return {
        ...state,
        playFailureVO: true,
      };
    case 'PREVENT_FAILURE_VO_PLAYING':
      return {
        ...state,
        playFailureVO: false,
      };

      // Quest Step Complete Screen
    case 'SHOW_SINGLE_STEP_MASTERED_SCREEN':
      return {
        ...state,
        showSingleStepMasteredScreen: true,
        showAllStepsMasteredScreen: false,
        showThreeFailuresScreen: false,
        playFailureVO: false,
      };
    case 'HIDE_SINGLE_STEP_MASTERED_SCREEN':
      return {
        ...state,
        showSingleStepMasteredScreen: false,
      };

    // Quest Complete Screen
    case 'SHOW_ALL_STEPS_MASTERED_SCREEN':
      return {
        ...state,
        showSingleStepMasteredScreen: false,
        showAllStepsMasteredScreen: true,
        showThreeFailuresScreen: false,
        playFailureVO: false,
      };
    case 'HIDE_ALL_STEPS_MASTERED_SCREEN':
      return {
        ...state,
        showAllStepsMasteredScreen: false,
      };

    // Augmentation reward screen
    case 'SHOW_AUGMENTATION_REWARD_SCREEN':
      return {
        ...state,
        showAugmentationNavigationScreen: true,
      };
    case 'HIDE_AUGMENTATION_REWARD_SCREEN':
      return {
        ...state,
        showAugmentationNavigationScreen: false,
      };
    default:
      return state;
  }
};

export default questNavigationReducer;
